import { Component, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Avatar } from 'primeng/avatar';
import { Button } from 'primeng/button';
import { Tag } from 'primeng/tag';
import { Tooltip } from 'primeng/tooltip';

import { chatCumpleLabel } from '../../../helpers/chat-cumpleanios';
import { capitalizeWords, formatNombreCompletoDisplay } from '../../../helpers/nombre-texto.helper';
import { buildAvatarStyle, buildIniciales } from '../../../helpers/map-congregacion-row';
import { calcEdadAnios } from '../../../pipes/edad.pipe';
import { ChatConversacion } from '../../../interfaces/chat.interface';

@Component({
  selector: 'app-chat-header',
  standalone: true,
  imports: [RouterLink, Avatar, Button, Tag, Tooltip],
  templateUrl: './chat-header.component.html',
})
export class ChatHeaderComponent {
  readonly conversacion = input.required<ChatConversacion>();
  /** La iglesia puede tener los niveles apagados. */
  readonly mostrarNivel = input(false);
  /** Vuelve a la lista; solo se dibuja en mobile, donde el detalle ocupa toda la pantalla. */
  readonly mostrarVolver = input(false);
  readonly mostrarCerrar = input(true);
  /** En la célula se muestra la edad en lugar del nombre del líder. */
  readonly mostrarEdad = input(false);

  readonly volver = output<void>();
  readonly cerrar = output<void>();

  readonly nombreCompleto = computed(() => {
    const conversacion = this.conversacion();
    return formatNombreCompletoDisplay(conversacion.nombre, '', conversacion.apellido);
  });

  readonly liderLabel = computed(() => capitalizeWords(this.conversacion().miLider));

  readonly iniciales = computed(() =>
    buildIniciales(this.conversacion().nombre, this.conversacion().apellido),
  );

  readonly avatarStyle = computed(() => ({
    ...buildAvatarStyle(this.conversacion().sexo),
    width: '2.5rem',
    height: '2.5rem',
    fontSize: '0.8rem',
  }));

  readonly cumpleLabel = computed(() => chatCumpleLabel(this.conversacion().nacimiento));

  readonly edadLabel = computed(() => {
    const anios = calcEdadAnios(this.conversacion().nacimiento);
    return anios === null ? null : `Edad: ${anios} años`;
  });
}
